import { Routes } from '@angular/router';
import { authRoutes } from './core/login/auth.routes';
import { homePageRoutes } from './features/homepage/homepage.routes';
import { userRoutes } from './features/users/user.routes';
import { leadsRoutes } from '@features/leads/leads.routes';
import { followUpRoutes } from '@features/follow-up/follow-up.routes';
import { treasurerRoutes } from '@features/treasurer/treasurer.routes';
import { emittersRoutes } from '@features/emitters/emitters.routes';
import { quotaRoutes } from '@features/quota/quota.routes';

export const routes: Routes = [
  ...authRoutes,
  ...homePageRoutes,
  ...userRoutes,
  ...leadsRoutes,
  ...followUpRoutes,
  ...treasurerRoutes,
  ...emittersRoutes,
  ...quotaRoutes,
  {
    path: '',
    redirectTo: '/login',
    pathMatch: 'full',
  },
  {
    path: '**',
    redirectTo: '/login',
    pathMatch: 'full',
  },
];
